import { routes } from "schemas/routes";

export function getOnboardingPage(currentPathname: string) {
  if (currentPathname.endsWith(routes.preferencesOnboarding)) {
    return "preferencesForm";
  } else if (currentPathname.endsWith(routes.aboutOnboarding)) {
    return "aboutForm";
  } else if (currentPathname.endsWith(routes.categoryOnboarding)) {
    return "categoryForm";
  }
}

export const getOnboardingSteps = (
  isSocialFlow: boolean,
  currentPath: string,
) => {
  let currentFlow = [routes.aboutOnboarding, routes.categoryOnboarding];

  if (isSocialFlow) {
    // Insert social onboarding steps at the beginning of the array
    currentFlow.unshift(routes.preferencesOnboarding);
  }

  let stepNumber = currentFlow.findIndex((step) => currentPath.includes(step));

  if (stepNumber > -1) {
    stepNumber += 1;
  }

  return { steps: currentFlow, currentStep: stepNumber };
};
